import React from "react";
import styles from "./ButtonWithLoadingState.module.scss";

interface Props {
	buttonText: string;
	loading?: boolean;
	buttonPressed?: (() => void) | null;
	isSecondary?: boolean;
	style?: React.CSSProperties;
}

export const ButtonWithLoadingState = ({
	buttonText,
	loading = false,
	buttonPressed,
	isSecondary = false,
	style,
}: Props) => {
	const spinnerClass = `${styles.spinner} ${isSecondary ? styles.spinnerSecondary : styles.spinnerPrimary}`;

	return (
		<button
			className={isSecondary ? "app-secondary-btn" : "app-primary-btn"}
			onClick={buttonPressed ?? undefined}
			disabled={!buttonPressed || loading}
			style={style}
		>
			{loading ? <span className={spinnerClass} /> : buttonText}
		</button>
	);
};
